const STORAGE_PREFIX = "sd:page-intro-dismissed:";

const key = (userId: string) => `${STORAGE_PREFIX}${userId}`;

const read = (userId: string): string[] => {
  try {
    const parsed: unknown = JSON.parse(
      window.localStorage.getItem(key(userId)) ?? "[]",
    );
    return Array.isArray(parsed)
      ? parsed.filter((entry): entry is string => typeof entry === "string")
      : [];
  } catch {
    return [];
  }
};

export const isPageIntroDismissed = (
  userId: string | undefined,
  introKey: string,
): boolean => (userId ? read(userId).includes(introKey) : false);

export const dismissPageIntro = (
  userId: string | undefined,
  introKey: string,
) => {
  if (!userId) return;
  const next = Array.from(new Set([...read(userId), introKey]));
  try {
    window.localStorage.setItem(key(userId), JSON.stringify(next));
  } catch {
    // storage unavailable; the popup will simply return next visit
  }
};
